/* =================================================================
   3-LEVEL COLLECTION HIERARCHY + AJAX
================================================================= */

let currentCollectionTitle = '';

function updateActiveCollection() {
  jQuery('.ajax-collection-tabs a.js-collection-switch.collection-tab')
    .removeClass('active-collection');
  var currentHandle = window.location.pathname.split('/')[2];
  jQuery('.ajax-collection-tabs a.js-collection-switch.collection-tab').each(function () {
    if (jQuery(this).attr('data-handle') === currentHandle) {
      jQuery(this).addClass('active-collection');
    }
  });
}

function updateCollectionTitle(forcedTitle) {
  if (forcedTitle) {
    currentCollectionTitle = forcedTitle;
  } else {
    const activeTab = document.querySelector('.ajax-collection-tabs a.js-collection-switch.active-collection .collection-tab__title')
                   || document.querySelector('.collection-tab.active-collection .collection-tab__title');
    if (activeTab) currentCollectionTitle = activeTab.textContent.trim();
  }
  if (!currentCollectionTitle) return;
  const heading = document.querySelector('.page-banner__title');
  if (heading) heading.textContent = currentCollectionTitle;
}

updateActiveCollection();
updateCollectionTitle();

(function(history){
  const pushState = history.pushState;
  history.pushState = function(state) {
    pushState.apply(history, arguments);
    updateActiveCollection();
  };
})(window.history);

window.addEventListener('popstate', function () {
  updateActiveCollection();
  updateCollectionTitle();
});


document.addEventListener('DOMContentLoaded', () => {

  /* =====================================================
     SCROLL ARROWS
  ===================================================== */
  const scrollSlider = document.getElementById('collection-scroll');
  const nextBtn      = document.querySelector('.collection-arrow--right');
  const prevBtn      = document.querySelector('.collection-arrow--left');
  const scrollAmount = 400;

  if (scrollSlider && nextBtn && prevBtn) {
    nextBtn.addEventListener('click', () => scrollSlider.scrollBy({ left:  scrollAmount, behavior: 'smooth' }));
    prevBtn.addEventListener('click', () => scrollSlider.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
  }

  /* =====================================================
     SKELETON HELPERS
  ===================================================== */
  function getTabSkeletonMarkup(count) {
    return Array(count || 6).fill(0).map(() => `
      <div class="collection-tab" style="flex:0 0 11.5%;">
        <div class="skeleton-image" style="height:200px;border-radius:0;"></div>
        <div class="skeleton-text skeleton-title" style="margin-top:8px;width:70%;margin-left:auto;margin-right:auto;"></div>
      </div>
    `).join('');
  }

  const productSkeletonMarkup = `
    <div class="skeleton-grid">
      ${Array(8).fill(0).map(() => `
        <div class="skeleton-card">
          <div class="skeleton-image"></div>
          <div class="skeleton-text skeleton-title"></div>
          <div class="skeleton-text skeleton-price"></div>
        </div>
      `).join('')}
    </div>
  `;

  /* =====================================================
     AJAX LOADER
     Strategy:
     - Keep dynamic-load-more element INTACT (never remove it)
     - On collection switch: remove extra appended grids
     - Replace only first grid content
     - Reset dynamic-load-more state + update its href
  ===================================================== */
  async function loadCollection(url, handle, tileLabel, onDone) {

    const outerContainer  = document.querySelector('.collection-grid-container');
    const skeletonOverlay = document.getElementById('product-skeleton');
    const childContainer  = document.getElementById('hierarchy-virtual-tiles');

    if (!outerContainer) return;

    /* tab skeleton */
    if (childContainer) {
      const count = childContainer.querySelectorAll('.hierarchy-tile').length;
      childContainer.style.pointerEvents = 'none';
      childContainer.innerHTML = getTabSkeletonMarkup(count);
    }

    outerContainer.style.display = '';
    if (skeletonOverlay) skeletonOverlay.classList.add('active');

    /* CLEANUP: remove extra grids Load More appended, keep only first */
    const allGrids = outerContainer.querySelectorAll('.collection__grid');
    allGrids.forEach((grid, i) => { if (i > 0) grid.remove(); });

    const allLoadMore = outerContainer.querySelectorAll('dynamic-load-more');
    allLoadMore.forEach((el, i) => { if (i > 0) el.remove(); });

    /* CLEANUP: remove dynamic-load-previous appended grids */
    outerContainer.querySelectorAll('dynamic-load-previous').forEach(el => el.remove());

    /* show skeleton in first (only) grid */
    const innerGrid = outerContainer.querySelector('.collection__grid');
    if (innerGrid) innerGrid.innerHTML = productSkeletonMarkup;

    try {
      const response = await fetch(`${url}?section_id=main-collection`);
      const html     = await response.text();
      const parser   = new DOMParser();
      const doc      = parser.parseFromString(html, 'text/html');
      /* replace first grid content with new collection products */
      const newInnerGrid = doc.querySelector('.collection__grid');
      if (newInnerGrid && innerGrid) {
        innerGrid.innerHTML = newInnerGrid.innerHTML;
      }

      /* reset dynamic-load-more — keep element, just update its state */
      const dynLoadMore = outerContainer.querySelector('dynamic-load-more');
      if (dynLoadMore) {
        dynLoadMore.dataset.currentPage = '1';
        dynLoadMore.classList.remove('hidden');
        /* update the load more button href inside it */
        const loadMoreBtn = dynLoadMore.querySelector('.js-btn-load-more');
        if (loadMoreBtn) {
          const basePath = url.split('?')[0];
          loadMoreBtn.dataset.href = `${basePath}?page=2`;
        }
      }

      /* remove any pagination that snuck in */
      outerContainer.querySelectorAll('.collection__actions').forEach(el => el.remove());

      history.pushState({}, '', url);
      updateActiveCollection();
      updateCollectionTitle(tileLabel || null);

    } catch (err) {
      console.error('[Collection AJAX]', err);
    }

    if (skeletonOverlay) skeletonOverlay.classList.remove('active');
    if (childContainer) childContainer.style.pointerEvents = '';
    if (onDone) onDone();
  }

  /* =====================================================
     ORIGINAL AJAX TAB CLICKS
  ===================================================== */
  document.querySelectorAll('.js-collection-switch').forEach(link => {
    link.addEventListener('click', async (e) => {
      e.preventDefault();
      const label = link.querySelector('.collection-tab__title')?.textContent.trim();
      await loadCollection(link.getAttribute('href'), link.dataset.handle, label);
    });
  });

  /* =====================================================
     HIERARCHY SETUP
  ===================================================== */
  const slider = document.getElementById('collection-scroll');
  if (!slider) return;

  const groups = window.COLLECTION_HIERARCHY || [];
  if (groups.length === 0) return;

  const wrapper          = document.getElementById('collection-scroll-wrapper');
  const allParentHandles = groups.map(g => g.parentHandle);

  let navStack = [];

  function hideRealSlider() { if (wrapper) wrapper.style.display = 'none'; }
  function showRealSlider() { if (wrapper) wrapper.style.display = ''; }
  function removeEl(id)     { const el = document.getElementById(id); if (el) el.remove(); }

  /* =====================================================
     BUILD CHILD SLIDER UI
  ===================================================== */
  function buildSliderUI(tiles, onTileClick) {
    removeEl('hierarchy-scroll-wrapper');
    removeEl('hierarchy-back');
    removeEl('hierarchy-back-to-parent');

    hideRealSlider();

    const childWrap = document.createElement('div');
    childWrap.id        = 'hierarchy-scroll-wrapper';
    childWrap.className = 'collection-scroll-wrappers';

    const leftArrow = document.createElement('button');
    leftArrow.className = 'collection-arrow collection-arrow--left';
    leftArrow.innerHTML = '←';

    const container = document.createElement('div');
    container.id        = 'hierarchy-virtual-tiles';
    container.className = 'ajax-collection-tabs collection-slider';

    const rightArrow = document.createElement('button');
    rightArrow.className = 'collection-arrow collection-arrow--right';
    rightArrow.innerHTML = '→';

    leftArrow.addEventListener('click',  () => container.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    rightArrow.addEventListener('click', () => container.scrollBy({ left:  scrollAmount, behavior: 'smooth' }));

    childWrap.appendChild(leftArrow);
    childWrap.appendChild(container);
    childWrap.appendChild(rightArrow);

    wrapper.parentNode.insertBefore(childWrap, wrapper);

    tiles.forEach(tile => {
      const realTab = slider.querySelector(`.js-collection-switch[data-handle="${tile.handle}"]`);
      const imgHTML = realTab
        ? realTab.querySelector('.collection-tab__image').outerHTML
        : `<div class="collection-tab__image collection-tab__image--placeholder"><span>${tile.label[0]}</span></div>`;

      const clone = document.createElement('div');
      clone.className = 'collection-tab hierarchy-tile';
      clone.innerHTML = imgHTML + `<span class="collection-tab__title">${tile.label}${tile.hasChildren ? ' ›' : ''}</span>`;

      clone.addEventListener('click', () => onTileClick(tile, clone, container));
      container.appendChild(clone);
    });

    const back = document.createElement('button');
    back.id        = 'hierarchy-back';
    back.innerHTML = '&#8592; Back';
    back.addEventListener('click', goBack);
    wrapper.parentNode.insertBefore(back, childWrap);

    container.scrollLeft = 0;
  }

  /* =====================================================
     SHOW BACK-TO-PARENT BUTTON
  ===================================================== */
  function showBackToParent() {
    removeEl('hierarchy-back-to-parent');
    if (navStack.length === 0) return;

    const label = navStack[navStack.length - 1].label;
    const btn   = document.createElement('button');
    btn.id        = 'hierarchy-back-to-parent';
    btn.innerHTML = `&#8592; Back to ${label}`;
    btn.addEventListener('click', () => {
      removeEl('hierarchy-back-to-parent');
      renderLevel();
    });
    const childWrap = document.getElementById('hierarchy-scroll-wrapper');
    if (childWrap) childWrap.parentNode.insertBefore(btn, childWrap);
  }

  /* =====================================================
     RENDER CURRENT LEVEL
  ===================================================== */
  function renderLevel() {
    if (navStack.length === 0) {
      showLevel1();
      return;
    }

    if (navStack.length === 1) {
      const parentHandle = navStack[0].handle;
      const group        = groups.find(g => g.parentHandle === parentHandle);
      if (!group) return;

      const tiles = group.subs.map(sub => ({
        label:       sub.label,
        handle:      sub.handle,
        hasChildren: sub.children && sub.children.length > 0,
        data:        sub
      }));

      buildSliderUI(tiles, (tile, clone, container) => {
        if (tile.hasChildren) {
          navStack.push({ label: tile.label, handle: tile.handle });
          renderLevel();
        } else {
          const realTab = slider.querySelector(`.js-collection-switch[data-handle="${tile.handle}"]`);
          const url     = realTab ? realTab.getAttribute('href') : `/collections/${tile.handle}`;
          const count   = container.querySelectorAll('.hierarchy-tile').length;
          container.style.pointerEvents = 'none';
          container.innerHTML = getTabSkeletonMarkup(count);
          loadCollection(url, tile.handle, tile.label, () => {
            container.style.pointerEvents = '';
            renderLevel();
            showBackToParent();
          });
        }
      });
      return;
    }

    if (navStack.length === 2) {
      const parentHandle = navStack[0].handle;
      const subHandle    = navStack[1].handle;
      const group        = groups.find(g => g.parentHandle === parentHandle);
      if (!group) return;
      const sub = group.subs.find(s => s.handle === subHandle);
      if (!sub) return;

      const tiles = sub.children.map(handle => {
        const realTab = slider.querySelector(`.js-collection-switch[data-handle="${handle}"]`);
        return {
          label:       realTab ? realTab.querySelector('.collection-tab__title').textContent.trim() : handle,
          handle:      handle,
          hasChildren: false
        };
      });

      buildSliderUI(tiles, (tile, clone, container) => {
        const realTab = slider.querySelector(`.js-collection-switch[data-handle="${tile.handle}"]`);
        const url     = realTab ? realTab.getAttribute('href') : `/collections/${tile.handle}`;
        const count   = container.querySelectorAll('.hierarchy-tile').length;
        container.style.pointerEvents = 'none';
        container.innerHTML = getTabSkeletonMarkup(count);
        loadCollection(url, tile.handle, tile.label, () => {
          container.style.pointerEvents = '';
          renderLevel();
          showBackToParent();
          document.querySelectorAll('#hierarchy-virtual-tiles .hierarchy-tile').forEach(t => {
            t.classList.toggle('active-collection',
              t.querySelector('.collection-tab__title')?.textContent.trim() === tile.label);
          });
        });
      });
    }
  }

  /* =====================================================
     LEVEL 1
  ===================================================== */
 function showLevel1() {
  removeEl('hierarchy-scroll-wrapper');
  removeEl('hierarchy-back');
  removeEl('hierarchy-back-to-parent');

  const currentHandle = window.location.pathname.split('/').filter(Boolean).pop();

  const currentGroup = groups.find(group =>
    group.parentHandle === currentHandle ||
    (group.subs || []).some(sub =>
      sub.handle === currentHandle ||
      (sub.children || []).includes(currentHandle)
    )
  );

  if (currentGroup) {
    const parentTab = slider.querySelector(
      `.js-collection-switch[data-handle="${currentGroup.parentHandle}"]`
    );

    const parentLabel =
      parentTab?.querySelector('.collection-tab__title')?.textContent.trim() ||
      currentGroup.parentHandle;

    navStack = [{
      label: parentLabel,
      handle: currentGroup.parentHandle
    }];

    renderLevel();
    return;
  }

  navStack = [];
  showRealSlider();

  slider.querySelectorAll('.js-collection-switch').forEach(tab => {
    tab.style.display = 'none';
  });

  groups.forEach(group => {
    const tab = slider.querySelector(
      `.js-collection-switch[data-handle="${group.parentHandle}"]`
    );

    if (tab) {
      tab.style.display = '';
      slider.appendChild(tab);
    }
  });

  slider.scrollLeft = 0;
}

  /* =====================================================
     GO BACK
  ===================================================== */
  function goBack() {
    navStack.pop();
    renderLevel();
  }

  /* =====================================================
     INTERCEPT PARENT TILE CLICKS
  ===================================================== */
  slider.querySelectorAll('.js-collection-switch').forEach(tab => {
    const handle = tab.dataset.handle;
    const group  = groups.find(g => g.parentHandle === handle);
    if (group) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        navStack = [{ label: group.parent, handle: group.parentHandle }];
        renderLevel();
      });
    }
  });

  showLevel1();

});

/* =====================================================
   SKELETON HELPERS
===================================================== */
const skeleton = document.getElementById('product-skeleton');
function showSkeleton() { if (skeleton) skeleton.classList.add('active'); }
function hideSkeleton() { if (skeleton) skeleton.classList.remove('active'); }